var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#DDF0E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.5C15.1125 9.5 9.5 15.1125 9.5 22C9.5 28.8875 15.1125 34.5 22 34.5C28.8875 34.5 34.5 28.8875 34.5 22C34.5 15.1125 28.8875 9.5 22 9.5ZM27.975 19.125L20.8875 26.2125C20.7125 26.3875 20.475 26.4875 20.225 26.4875C19.975 26.4875 19.7375 26.3875 19.5625 26.2125L16.025 22.675C15.6625 22.3125 15.6625 21.7125 16.025 21.35C16.3875 20.9875 16.9875 20.9875 17.35 21.35L20.225 24.225L26.65 17.8C27.0125 17.4375 27.6125 17.4375 27.975 17.8C28.3375 18.1625 28.3375 18.75 27.975 19.125Z",
    fill: "#07AF40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.97cec6c662e8710b70d10322b846e0f8.svg";
export { ForwardRef as ReactComponent };